// src/routes/AppRoutes.tsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../pages/HomePage/HomePage";
import Notification from "../pages/NotificationPage/NotificationPage";
import SecurityAndPrivacy from "../pages/SecurityAndPrivacyPage/SecurityAndPrivacyPage";
import PayoutMethod from "../pages/PayoutMethodPage/PayoutMethodPage";
import Display from "../pages/DisplayPage/DisplayPage";
import { EditProfile } from "../pages/UserProfile/EditProfile";
import { Following } from "../pages/FollowingPage/FollowingPage";
import Memberships from "../pages/MembershipsPage/MembershipsPage";
import { AlertPage } from "../pages/AlertPage/AlertPage";
import PrivateMessage from "../pages/PrivateMessagePage/PrivateMessagePage";
import ProtectedRoute from "./ProtectedRoutes";
import RankingPage from "../pages/RankingPage/RankingPage";
import LearnPage from "../pages/StaticPage/LearnPage/LearnPage";
import HelpPage from "../pages/StaticPage/HelpPage/HelpPage";
import AboutPage from "../pages/StaticPage/AboutPage/AboutPage";
import ContactPage from "../pages/StaticPage/ContactPage/ContactPage";
import PhilanthropyPage from "../pages/StaticPage/PhilanthropyPage/PhilanthropyPage";
import AvailablePage from "../pages/AvailablePage/AvailablePage";
import SearchPage from "../pages/SearchResultPage/SearchPage";
// import MembershipHistory from "../pages/MembershipHistoryPage/MembershipHistoryPage";
import ListingProfile from "../pages/ListingProfilePage/ListingProfile";
import ListingRoute from "./ListingRoute";
import TermsAndService from "../pages/StaticPage/TermsAndServicesPage/TermsAndService";
import PrivacyPage from "../pages/StaticPage/PrivacyPage/PrivacyPage";
import FanPage from "../pages/StaticPage/FanPage/FanPage";
import FamousPage from "../pages/StaticPage/FamousPage/FamousPage";
import CodeOfConductPage from "../pages/StaticPage/CodeOfConductPage/CodeOfConductPage";
import FanPublic from "../pages/FanPublicPage/FanPublicPage";
import NotableUserTerms from "../pages/StaticPage/NotableUserTerms/NotableUserTerms";
import EmailResubscribePage from "../pages/StaticPage/EmailUnsubscribePage/EmailResubscribePage";
import SignUp from "../pages/SignUpPage/SignUpPage";

const AppRoutes: React.FC<{
  handleImageChange: (newImageUrl: string) => void;
  notifications?: any;
  userRole: string;
  handleScrollToTop?: () => void;
}> = ({
  handleImageChange,
  notifications,
  userRole,
  handleScrollToTop
}) => {
    return (
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<Navigate to="/" />} />
        {/* Protected Routes */}
        <Route
          path="/:userParam"
          element={
            <ListingRoute
            />
          }
        />
        <Route
          path="/u/:username"
          element={<FanPublic />}
        />

        <Route
          path="/settings/listing"
          element={
            <ProtectedRoute>
              <ListingProfile userRole={userRole} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/notifications"
          element={
            <ProtectedRoute>
              <Notification userRole={userRole} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/secpriv"
          element={
            <ProtectedRoute>
              <SecurityAndPrivacy userRole={userRole} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/method"
          element={
            <ProtectedRoute>
              <PayoutMethod userRole={userRole} />
            </ProtectedRoute>
          }
        />
        {/* <Route
        path="/settings/history"
        element={
          <ProtectedRoute>
            <MembershipHistory userRole={userRole}/>
          </ProtectedRoute>
        }
      /> */}
        <Route
          path="settings/profile"
          element={
            <ProtectedRoute>
              <EditProfile handleImageChange={handleImageChange} userRole={userRole} />
            </ProtectedRoute>
          }
        />

        <Route path="/fans" element={<FanPage handleScrollToTop={handleScrollToTop} />} />

        <Route path="/famous" element={<FamousPage />} />

        <Route path="/rankings" element={<RankingPage />} />

        <Route path="/available" element={<AvailablePage />} />

        <Route path="/search" element={<SearchPage />} />

        <Route path="/search/:query" element={<SearchPage />} />

        <Route
          path="/display-preference"
          element={
            <ProtectedRoute>
              <Display userRole={userRole} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/following"
          element={
            <ProtectedRoute>
              <Following />
            </ProtectedRoute>
          }
        />
        <Route
          path="/message"
          element={
            <ProtectedRoute>
              <PrivateMessage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/alerts"
          element={
            <ProtectedRoute>
              <AlertPage notifications={notifications} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/memberships"
          element={
            <ProtectedRoute>
              <Memberships />
            </ProtectedRoute>
          }
        />
        <Route path="/learn" element={<LearnPage handleScrollToTop={handleScrollToTop} />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/philanthropy" element={<PhilanthropyPage />} />
        <Route path="/terms" element={<TermsAndService />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/codeofconduct" element={<CodeOfConductPage />} />
        <Route path="/notableuserterms" element={<NotableUserTerms />} />
        <Route path="/emailresubscribe" element={<EmailResubscribePage/>} />
        <Route path="/signup" element={<SignUp/>}/>
      </Routes>
    );
  };

export default AppRoutes;
